import { validateAnswer } from "@/commands/answer/validate-answer";
import type { Answer } from "@/commands/answer/answer";
import { CliError } from "@/lib/cli/cli-error";

export function parseAnswerEntry(entry: unknown, label: string): Answer {
  if (!entry || typeof entry !== "object" || Array.isArray(entry)) {
    throw new CliError(`${label} must be an object.`, 2);
  }

  const answer = entry as Record<string, unknown>;
  if (typeof answer.questionId !== "string") {
    throw new CliError(`${label} needs a non-empty "questionId".`, 2);
  }
  if (
    answer.selectedOptionIds !== undefined &&
    (!Array.isArray(answer.selectedOptionIds) ||
      answer.selectedOptionIds.some((id) => typeof id !== "string"))
  ) {
    throw new CliError(
      `${label}.selectedOptionIds must be an array of strings.`,
      2,
    );
  }
  if (answer.freeText !== undefined && typeof answer.freeText !== "string") {
    throw new CliError(`${label}.freeText must be a string.`, 2);
  }

  const parsed = entry as Answer;
  validateAnswer(parsed, label);
  return parsed;
}
